import { OwnerInformationTab } from './OwnerInformationTab';

export default OwnerInformationTab;
